import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Home } from "./Home";
import Demo1 from "./Pages/Demos/Demo1";
import Demo0 from "./Pages/Demos/Demo0";

import page404 from "./Pages/page404";

class App extends Component {
  componentDidMount() {
    this.props.hideLoader();
  }
  render() {
    return (
      <React.Fragment>
        <Router>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/demo0" component={Demo0}/>
            <Route exact path="/demo1" component={Demo1}/>
            <Route exact path="/demo2" render={() => {window.location.href=process.env.PUBLIC_URL+"/demo2/index.html"}} />
            <Route exact path="/demo3" render={() => {window.location.href=process.env.PUBLIC_URL+"/demo3/index.html"}} />
            <Route path="/*" component={page404} />
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

export default App;
